// Recharts colors per console theme. SVG attributes (stroke/fill) don't
// resolve CSS var(), so the chart palette is concrete per theme and
// re-rendered when the theme toggles.
import { docTheme } from '../hooks/useTheme';

export function useConsoleTheme() {
  return docTheme();
}

export function chartThemeColors(theme) {
  if (theme === 'light') {
    return {
      tooltipBg: '#ffffff',
      tooltipBorder: '#97a5bd',
      tooltipText: '#16202f',
      grid: '#c3ccdc',
      axis: '#52607a',
    };
  }
  return {
    tooltipBg: '#1e293b',
    tooltipBorder: '#334155',
    tooltipText: '#f8fafc',
    grid: '#334155',
    axis: '#94a3b8',
  };
}

export function chartTooltipStyle(theme, fontSize) {
  const c = chartThemeColors(theme);
  return {
    backgroundColor: c.tooltipBg,
    borderColor: c.tooltipBorder,
    color: c.tooltipText,
    outline: 'none',
    ...(fontSize ? { fontSize } : {}),
  };
}